import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const LogoutContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 16px 40px;
`;

export const StyledLogoutButton = styled.button`
  font-family: "Noto Sans Hebrew", sans-serif;
  padding: 10px 28px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid ${colors.lightGrayBlue};
  background: ${colors.white};
  color: ${colors.blueGray};

  &:hover {
    border-color: ${colors.blueGray};
    color: ${colors.darkBlue};
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ConfirmOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.darkBlueAlpha80};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
`;

export const ConfirmDialog = styled.div`
  background-color: ${colors.white};
  border-radius: 12px;
  padding: 32px;
  max-width: 340px;
  width: 100%;
  box-shadow: 0 8px 32px ${colors.darkBlueAlpha59};
  direction: rtl;
  text-align: center;
`;

export const ConfirmTitle = styled.h3`
  color: ${colors.darkBlue};
  font-size: 18px;
  font-weight: 500;
  margin: 0 0 8px 0;
  font-family: "Noto Sans Hebrew", sans-serif;
`;

export const ConfirmMessage = styled.p`
  color: ${colors.blueGray};
  font-size: 14px;
  margin: 0 0 24px 0;
  font-family: "Noto Sans Hebrew", sans-serif;
  line-height: 1.5;
`;

export const ConfirmButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

export const ConfirmButton = styled.button<{ $variant: "confirm" | "cancel" }>`
  font-family: "Noto Sans Hebrew", sans-serif;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 40px;

  ${({ $variant }) =>
    $variant === "confirm"
      ? `
    background: ${colors.red};
    color: ${colors.white};
    border: none;
    &:hover {
      opacity: 0.9;
      transform: translateY(-1px);
    }
  `
      : `
    background: ${colors.white};
    color: ${colors.darkBlue};
    border: 1px solid ${colors.lightGrayBlue};
    &:hover {
      border-color: ${colors.blueGray};
      transform: translateY(-1px);
    }
  `}

  &:active {
    transform: translateY(0);
  }
`;
